import { render, staticRenderFns } from "./AppTown.vue?vue&type=template&id=458ae1de&"
import script from "./AppTown.vue?vue&type=script&lang=js&"
export * from "./AppTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports